/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Civil_Fly_FeelInputs */

const fr_teal_civil_fly_feel = /** @type {(inputs: Teal_Civil_Fly_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez les permissions spécifiques pour cet utilisateur. Les permissions peuvent être héritées
			du rôle de base ou surchargées individuellement.`)
};

/**

* @param {Teal_Civil_Fly_FeelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teal_civil_fly_feel = /** @type {((inputs?: Teal_Civil_Fly_FeelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Civil_Fly_FeelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teal_civil_fly_feel(inputs)
});